<router-outlet name="popup"></router-outlet>
<div *ngIf="loading" class="d-flex loading-spinner">
    <!-- <mat-spinner color="warn" diameter="20"></mat-spinner> -->
    <div class=" eac-label-input">Carregant...</div>
</div>
<ng-container *ngIf="configService.config.connectedEntityDetail!=null&&anonymous==false">
    <!-- The 404 page (notFound) is painted without the shell toolbar: it has its own header -->
    <ng-container *ngIf="notFound || (menuItems.length>0 && menuItems[0].url.indexOf('fullscreen')>=0)">
        <ng-container *ngTemplateOutlet="fullScreen"></ng-container>
    </ng-container>
    <ng-container *ngIf="!notFound && (menuItems.length==0 ||menuItems[0].url.indexOf('fullscreen')<0)">
        <ng-container *ngTemplateOutlet="toolbarPage"></ng-container>
    </ng-container>
</ng-container>
<!-- This is only for full screen pages that are anonymous -->
<ng-container *ngIf="anonymous==true">
    <ng-container *ngIf="menuItems.length>0 && menuItems[0].url.indexOf('fullscreen')>=0">
        <ng-container *ngTemplateOutlet="fullScreen"></ng-container>
    </ng-container>
</ng-container>

<ng-template #fullScreen>
    <main [class.contrast-mode]="contrastMode">
        <router-outlet></router-outlet>
    </main>
</ng-template>

<ng-template #toolbarPage>
    <mat-toolbar color="primary" class="mat-bg-primary-800"
        style="height: 56px; padding-left: 16px; padding-right: 16px;">
        <ng-container *ngIf="isAdminOption()==false" [ngTemplateOutlet]="publicArea">

        </ng-container>
        <ng-container *ngIf="isAdminOption()" [ngTemplateOutlet]="privateArea">

        </ng-container>
        <button *ngIf="isAdminOption() && settingButton.currentOption==null" aria-label="preferencies" class="btn-menu"
            [matMenuTriggerFor]="menuSettings" name="menuSettings" mat-icon-button>
            <mat-icon class="material-icons-outlined">settings</mat-icon>
        </button>
        <button *ngIf="isAdminOption() && settingButton.currentOption!=null" aria-label="preferencies" class="btn-menu"
            (click)="settingButton.currentOption()" name="menuSettings" mat-icon-button>
            <mat-icon class="material-icons-outlined">settings</mat-icon>
        </button>
        <app-breadcrumb [adminBreadcrumb]="isAdminOption()">

        </app-breadcrumb>
        <span class="icons-spacer"></span>
        <button *ngIf="isAdminOption() == false  && settingButton.currentOption==null" aria-label="ajuda"
            class="btn-menu" [matMenuTriggerFor]="menuHelp" name="menuHelp" mat-icon-button>
            <mat-icon class="material-icons">help_outline</mat-icon>
        </button>
        <button *ngIf="isAdminOption() == false" aria-label="notificacions" class="btn-menu" mat-icon-button>
            <mat-icon class="material-icons-outlined">notifications</mat-icon>
        </button>
        <button *ngIf="isAdminOption() == false  && settingButton.currentOption==null && hasAnyProfile()" aria-label="preferencies"
            class="btn-menu" [matMenuTriggerFor]="menuSettings" name="menuSettings" mat-icon-button>
            <mat-icon class="material-icons-outlined">settings</mat-icon>
        </button>
        <button *ngIf="isAdminOption() == false  && settingButton.currentOption!=null" aria-label="preferencies"
            class="btn-menu" name="menuSettings" (click)="settingButton.currentOption()" mat-icon-button>
            <mat-icon class="material-icons-outlined">settings</mat-icon>
        </button>
        <button *ngIf="isAdminOption() == false" mat-icon-button aria-label="serveis" class="btn-menu"
            [matMenuTriggerFor]="menuApps" (menuOpened)="reloadApps()">
            <mat-icon>apps</mat-icon>
        </button>

        <div *ngIf="isAdminOption() == false" class="d-flex justify-content-center align-items-center login-widget"
            style="gap: 8px; cursor: pointer;">
            <div *ngIf="configService.config.connectedEntityDetail!=null" [matMenuTriggerFor]="menuUser"
                class="circle d-flex justify-content-center align-items-center"
                [class]="'color'+configService.config.connectedEntityDetail.entity.entityInfo.getNameInitialColorIndex()">

                <div style="padding-right: 1px;">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.name.charAt(0).toUpperCase()}}
                </div>
            </div>
            <div *ngIf="configService.config!=null" [matMenuTriggerFor]="menuUser"
                class="d-flex justify-content-center align-items-center" style="flex: 1 0 0;">

                <div class="d-flex flex-column" style="flex: 1 0 0;">
                    <div class="overline" style="    max-width: 260px;
                    overflow: hidden;
                    text-overflow: ellipsis;"
                    data-test="userEntity_Test">
                        {{configService.config.connectedEntityDetail.entity.entityInfo.name}}
                    </div>
                    <div class="mat-caption" style="color:unset" data-test="userLogged_Test">{{configService.config.connectedUser.name}}</div>
                </div>
                <button aria-label="personal" mat-icon-button>
                    <mat-icon class="material-icons-outlined">arrow_drop_down</mat-icon>
                </button>
            </div>
        </div>

        <div *ngIf="isAdminOption() == true" class="d-flex justify-content-center align-items-center login-widget"
            style="gap: 0px; cursor: pointer; width: fit-content;">

            <div *ngIf="configService.config.connectedEntityDetail!=null" [matMenuTriggerFor]="adminMenuUser"
                class=" d-flex justify-content-center align-items-center">
                <!-- {{configService.config.connectedEntityDetail.entity.id}} -->
                <!-- [class]="'color'+configService.config.connectedEntityDetail.entity.entityInfo.getNameInitialColorIndex()" -->
                <div class="eac-label-input" style="color: white;">
                    {{configService.config.connectedUser.name}}
                </div>
            </div>
            <div *ngIf="configService.config!=null" [matMenuTriggerFor]="adminMenuUser"
                class="d-flex justify-content-center align-items-center" style="flex: 1 0 0;">

                <button aria-label="personal" mat-icon-button>
                    <mat-icon class="material-icons-outlined">arrow_drop_down</mat-icon>
                </button>
            </div>
        </div>
    </mat-toolbar>
    <main [class.contrast-mode]="contrastMode">
        <router-outlet></router-outlet>
    </main>
</ng-template>

<mat-menu #adminMenuUser="matMenu">
    <div style="width: 400px; min-width: 400px; max-width: 400px;">

    </div>
    <button mat-menu-item aria-label="Espai personal" routerLink="/home/myaccount/my-account-home">
        <mat-icon class="material-icons-outlined eac-c1">account_circle</mat-icon>Espai personal
    </button>
    <button mat-menu-item aria-label="inici" routerLink="/" (click)="clickOnHome()">
        <mat-icon class="material-icons-outlined eac-c1">arrow_back</mat-icon>Tornar a inici
    </button>
    <button mat-menu-item aria-label="tancar sessio" (click)="doLogout()">
        <mat-icon class="material-icons-outlined eac-c1">logout</mat-icon>Tancar sessió
    </button>
    <div style="padding: 8px 0px;">
        <mat-divider></mat-divider>
    </div>
    <div class="d-flex align-items-center  justify-content-center  mat-caption" style="padding: 12px 16px;">
        <a style="text-decoration: underline; color: unset;" href="https://www.aoc.cat/avis-legal/" target="_blank">
            Avís legal
        </a>
        <span style="text-decoration: none; padding-left: 6px; padding-right: 6px;">·</span>
        <a style="text-decoration: underline;  color: unset;" href="https://www.aoc.cat/accessibilitat/" target="_blank">
            Accessibilitat
        </a>
    </div>
    <div class="eac-label-caption d-flex justify-content-center eac-c1">
        Hora oficial: {{ now()| date: 'hh:mm'}} - {{ now()| date: 'dd/MM/yyyy'}}
    </div>
    <div style="padding: 12px 16px; ">
        <mat-divider></mat-divider>
    </div>
    <div class="d-flex" style="padding: 12px 16px; padding-top: 0px;">
            <div class="logo-aoc" style="margin-left: 40px;"></div>
            <div style="flex: 0.5 0 0"></div>
            <div class="logo-eu"></div>
        </div>
        <div class="d-flex" style="padding: 12px 16px; padding-top: 0px;">
            <div class="logo-gencat" style="margin-left: 80px;"></div>
            <div style="flex: 0.5 0 0"></div>
            <div class="logo-localret" style="margin-right: 65px; margin-top: 5px;"></div>
        </div>
</mat-menu>

<mat-menu #menuUser="matMenu">
    <div style="max-width: 400px;  min-width: 400px; max-width: 400px;">
        <ng-container *ngIf="configService.config.connectedEntityDetail!=null">
            <div class="header-entity" style="padding-bottom: 8px;">
                <div class="d-flex justify-content-center align-items-center menu-item" style="cursor: pointer;"
                    (click)="openEntityInfo()">
                    <div class="circle d-flex justify-content-center align-items-center"
                        [class]="'color'+configService.config.connectedEntityDetail.entity.entityInfo.getNameInitialColorIndex()"
                        style="width: 40px; height: 40px;">
                        <div>
                            {{configService.config.connectedEntityDetail.entity.entityInfo.name.charAt(0).toUpperCase()}}
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center menu-item flex-wrap"
                    style="cursor: pointer; text-align: center;" (click)="openEntityInfo()">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.name}}
                </div>
            </div>
            <div *ngIf="configService.config.entities.length>0" style="padding-top: 12px;">
                <mat-divider></mat-divider>
            </div>
            <div class="overline eac-c1" *ngIf="configService.config.entities.length>0"
                style="padding: 16px 0 8px 16px;">Altres entitats
            </div>
            <ng-container *ngFor="let current of configService.config.entities.slice(0,6); let index = index">
                <div *ngIf="current.entity.id!= configService.config.connectedEntityDetail.entity.id"
                    (click)="changeEntity(current.userEntity.id, current.entity.id)" mat-menu-item class="d-flex align-items-center"
                    style="gap: 8px; padding-right: 16px;">

                    <div class="circle d-flex justify-content-center align-items-center"
                        [class]="'color'+current.entity.entityInfo.getNameInitialColorIndex()">
                        <div>
                            {{current.entity.entityInfo.name.charAt(0).toUpperCase()}}
                        </div>
                    </div>
                    <div [id]="'changeEntity-'+current.entity.entityInfo.ine10"
                        style="max-width: 380px; overflow: hidden; text-overflow: ellipsis;">
                        {{current.entity.entityInfo.name}}
                    </div>
                </div>
            </ng-container>
            <div *ngIf="configService.config.entities.length>5" style="padding-left: 16px;" (click)="openEntities()"
                mat-menu-item class="eac-label-button">
                Veure tot
            </div>
            <div style="padding: 8px 0px;">
                <mat-divider></mat-divider>
            </div>
            <div class="overline eac-c1" style="padding: 8px 0 8px 16px;">
                {{configService.config.connectedUser.name}}
            </div>
            <button mat-menu-item aria-label="Espai personal" routerLink="/home/myaccount/my-account-home">
                <mat-icon class="material-icons-outlined">account_circle</mat-icon>Espai personal
            </button>
            <button mat-menu-item aria-label="Serveis favorits" routerLink="bookmarks">
                <mat-icon class="material-icons-outlined">bookmarks</mat-icon>Serveis favorits
            </button>
            <div style="padding: 8px 0px;">
                <mat-divider></mat-divider>
            </div>
            <button mat-menu-item aria-label="tancar sessio" (click)="doLogout()">
                <mat-icon class="material-icons-outlined">logout</mat-icon>Tancar sessió
            </button>
        </ng-container>
        <div style="padding-top: 8px;">
            <mat-divider></mat-divider>
        </div>
        <div class="d-flex align-items-center  justify-content-center  mat-caption"
            style="padding: 12px 16px; padding-bottom: 4px;">
            <a style="text-decoration: underline; color: unset;" href="https://www.aoc.cat/avis-legal/"
                target="_blank">Avis legal</a>
            <span style="text-decoration: none; padding-left: 6px; padding-right: 6px;">·</span>
            <a style="text-decoration: underline;  color: unset;" href="https://www.aoc.cat/accessibilitat/"
                target="_blank">Accessibilitat</a>
        </div>
        <div class="eac-label-caption d-flex justify-content-center eac-c1">
            Hora oficial: {{ now()| date: 'HH:mm'}} - {{ now()| date: 'dd/MM/yyyy'}}
        </div>
        <div style="padding: 12px 16px; ">
            <mat-divider></mat-divider>
        </div>
        <div class="d-flex" style="padding: 12px 16px; padding-top: 0px;">
            <div class="logo-aoc" style="margin-left: 40px;"></div>
            <div style="flex: 0.5 0 0"></div>
            <div class="logo-eu"></div>
        </div>
        <div class="d-flex" style="padding: 12px 16px; padding-top: 0px;">
            <div class="logo-gencat" style="margin-left: 80px;"></div>
            <div style="flex: 0.5 0 0"></div>
            <div class="logo-localret" style="margin-right: 65px; margin-top: 5px;"></div>
        </div>
    </div>
</mat-menu>

<mat-menu #menuHelp="matMenu">

    <div class="mat-subheading-2" style="display: flex; align-items: center; padding: 12px 16px; width: 368px;">Ajuda</div>

    <div style="padding: 8px 0px; padding-bottom: 8px;">
        <mat-divider></mat-divider>
    </div>
    <button mat-menu-item aria-label="Suport" class="d-flex align-items-center" style="height: 40px;gap: 12px;" (click)="goToSuport()">
        <mat-icon class="material-icons-outlined">support</mat-icon>
        <div class="d-flex flex-column justify-content-center" style="height: 100%;">
            <div>Suport</div>
        </div>
    </button>
    <button mat-menu-item aria-label="Campus formació" class="d-flex align-items-center" style="height: 40px;gap: 12px;" (click)="goToSchool()">
        <mat-icon class="material-icons-outlined">slideshow</mat-icon>
        <div class="d-flex flex-column justify-content-center" style="height: 100%;">
            <div>Campus formació</div>
        </div>
    </button>
    <button mat-menu-item aria-label="Glossari de termes" class="d-flex align-items-center" style="height: 40px; gap: 12px;" (click)="goToGlossari()">
        <mat-icon class="material-icons-outlined">format_list_bulleted</mat-icon>
        <div class="d-flex flex-column justify-content-center" style="height: 100%;">
            <div>Glossari de termes</div>
        </div>
    </button>
    <button mat-menu-item aria-label="Blog" class="d-flex align-items-center" style="height: 40px;gap: 12px;" (click)="goToBlog()">
        <mat-icon class="material-icons-outlined">rss_feed</mat-icon>
        <div class="d-flex flex-column justify-content-center" style="height: 100%;">
            <div>Blog</div>
        </div>
    </button>
</mat-menu>

<mat-menu #menuSettings="matMenu">
    <div class="mat-subheading-2" style="display: flex; align-items: center; padding: 12px 16px;">Administració</div>

    <div *ngIf="hasEnsAdminOrEnsServiceProfile()" style="padding: 8px 0px; padding-bottom: 8px;">

        <mat-divider></mat-divider>
    </div>
    <button *ngIf="hasEnsAdminOrEnsServiceProfile()" mat-menu-item (click)="goToEnsAdmin()" name="ensAdmin"
        aria-label="configuració" class="d-flex align-items-start" style="height: 68px; gap: 12px; white-space: normal;">
        <app-icon-circle class="procedure-circle" scale="1.0" iconClass="material-icons-outlined" style="padding-top: 12px;">
            settings
        </app-icon-circle>
        <div class="d-flex flex-column justify-content-center" style="height: 100%; width: 400px;">
            <div class="mat-subheading-1">EACAT Tràmits</div>
            <div class="eac-label-caption" style="width: 400px;">
                Administra els accessos de les persones usuàries als serveis de tramitació interadministrativa en la teva entitat.
            </div>
        </div>
    </button>
    <button *ngIf="hasEnsAdmin() || hasManagerApps()" mat-menu-item (click)="goToCrossAdmin()" name="crossAdmin"
        aria-label="configuració" class="d-flex align-items-start" style="height: 68px; gap: 12px; white-space: normal;">
        <app-icon-circle class="procedure-circle" scale="1.0" iconClass="material-icons-outlined" style="padding-top: 12px;">
            settings
        </app-icon-circle>
        <div class="d-flex flex-column justify-content-center" style="height: 100%; ">
            <div class="mat-subheading-1">Serveis AOC</div>
            <div class="eac-label-caption" style="width: 400px;">
                Administra les persones usuàries i els seus permisos als serveis de l'AOC en la teva entitat.
            </div>
        </div>
    </button>
    <div *ngIf="hasAdminProfile()" style="padding-top: 8px; padding-bottom: 8px;">
        <mat-divider></mat-divider>
    </div>
    <button *ngIf="hasAdminProfile()" mat-menu-item (click)="goToEacAdmin()" name="eacAdmin"
        aria-label="configuració" class="d-flex align-items-start" style="height: 68px; gap: 12px; white-space: normal;">
        <app-icon-circle class="procedure-circle" scale="1.0" iconClass="material-icons-outlined" style="padding-top: 12px;">
            settings
        </app-icon-circle>
        <div class="d-flex flex-column justify-content-center" style="height: 100%;">
            <div class="mat-subheading-1">EACAT</div>
            <div class="eac-label-caption"  style="width: 400px;">
                Administra el funcionament de la plataforma per a totes les entitats.
            </div>
        </div>
    </button>
</mat-menu>

<ng-template #publicArea>
    <button mat-icon-button class="btn-menu" aria-label="to change">
        <mat-icon (click)="onMenu()">menu</mat-icon>
    </button>
    <img src="assets/eacat_logo.svg" alt="logo empresa" style="padding-left: 16px; padding-right: 8px;">
    <span *ngIf="showPreprodIndicator" class="preprod-indicator">PREPRODUCCIÓ</span>
    <button mat-icon-button class="btn-menu" aria-label="inici" routerLink="/" (click)="clickOnHome()" data-test="homeHouseIcon_Test">
        <mat-icon>home</mat-icon>
    </button>
</ng-template>

<ng-template #privateArea>
    <div style="padding-left: 10px;">
        <button mat-icon-button class="btn-menu" aria-label="inici" routerLink="/" (click)="clickOnHome()" data-test="goHome_Test">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <img src="assets/eacat_logo_min.png" alt="logo empresa" style="padding-left: 16px; padding-right: 16px;">
    <span *ngIf="showPreprodIndicator" class="preprod-indicator">PREPRODUCCIÓ</span>
    <span class="mat-body">{{menuItems[0].name}}</span>
    <div style="padding-left: 8px; padding-right: 8px;">
        <mat-divider class="the-divider" [vertical]="true"></mat-divider>
    </div>
</ng-template>

<mat-menu #menuApps="matMenu">
    <div class="d-flex align-items-center" style="padding: 12px 24px;">
        <div class="mat-title">Serveis AOC</div>
        <div style="flex: 1 0 0;"></div>
        <app-help-label (click)="$event.stopPropagation()" toolTipMsg="És el conjunt de serveis que l'AOC facilita a les administracions públiques catalanes. La gran majoria dels serveis són prestats directament per l'AOC i tenen relació amb la tramitació" [iconClass]="'eac-c1'" [size]="'big'"></app-help-label>
    </div>
    <mat-divider></mat-divider>
    <div class="d-flex flex-wrap" style="width: 1272px; padding: 8px 16px;">
      <div *ngFor="let app of aocApps" class="d-flex app_option align-items-start"
          [class.tall]=" app.name.length > 39"
          style="cursor: pointer;"
          (click)="openApp(app)">
          <div class="d-flex flex-column" >
              <div [class]="app.code+' logo '">

              </div>
              <div class="eac-label-caption eac-c1" style="padding-top: 0px; width: 265px;">{{app.name}}</div>
          </div>
          <div style="flex: 1 0 0"></div>
          <mat-icon class="app-icon eac-c1">open_in_new</mat-icon>
        </div>
    </div>

    <mat-divider></mat-divider>
    <div class="d-flex align-items-center" style="padding: 12px 24px;">
        <div class="mat-title">Serveis Externs</div>
        <div style="flex: 1 0 0;"></div>
    </div>
    <div class="d-flex flex-wrap" style="width: 1272px; padding: 8px 16px;">
      <div *ngFor="let app of externApps" class="d-flex app_option align-items-start"
          [class.tall]=" app.name.length > 37"
          style="cursor: pointer;"
          (click)="openApp(app)">
          <div class="d-flex flex-column">
              <div [class]="app.code+' logo '"></div>
              <div class="eac-label-caption eac-c1" style="padding-top: 0px; width: 265px;">{{app.name}}</div>
          </div>
          <div style="flex: 1 0 0"></div>
          <mat-icon class="app-icon eac-c1">open_in_new</mat-icon>
      </div>
  </div>

</mat-menu>

<ng-template #searchEntities>
    <div class="search-entities">
        <app-page-dialog style="min-height: 730px;">
            <div dialogTitle>
                <div class="mat-title">Canviar d'ens</div>
            </div>
            <div dialogHeader class="d-flex flex-column">
                <div>Selecciona el ens al qual vols accedir.</div>
                <form class="example-form" style="width: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-icon matPrefix>search</mat-icon>
                        <input #data type="text" matInput style="width: 100%;" (keyup)="doFilterEntities(data.value)">
                    </mat-form-field>
                </form>
            </div>
            <div dialogBody class="d-flex flex-column" style="padding-right: 8px;">
                <ng-container *ngFor="let current of filteredEntities; let index = index">
                    <div (click)="changeEntity(current.userEntity.id, current.entity.id)" class="d-flex align-items-center entity-search-item"
                        *ngIf="configService.config.connectedEntityDetail.entity.id != current.entity.id"
                        style="gap: 8px; min-height: 56px; margin-right: -24px; padding-left: 8px; margin-left: -8px;">

                        <div class="circle d-flex justify-content-center align-items-center"
                            [class]="'color'+current.entity.entityInfo.getNameInitialColorIndex()">
                            <div>
                                {{current.entity.entityInfo.name.charAt(0).toUpperCase()}}
                            </div>
                        </div>
                        <div [id]="'changeEntity-'+current.entity.entityInfo.ine10">
                            {{current.entity.entityInfo.name}}
                        </div>
                        <div style="flex: 1 0 0;"></div>
                        <button class="entity-search-item-icon" mat-icon-button>
                            <mat-icon class="eac-c1">chevron_right</mat-icon>
                        </button>
                    </div>
                </ng-container>
                <div style="flex: 1 0 0;"></div>
            </div>
            <div dialogFooter style="padding-top: 8px;">
                <mat-divider></mat-divider>
                <div class="d-flex justify-content-end" style="padding-top: 8px;">
                    <button mat-stroked-button matDialogClose="true">Cancel·lar</button>
                </div>
            </div>
        </app-page-dialog>
    </div>
</ng-template>

<ng-template #entityInfo>
    <div style="padding: 24px 32px 32px 32px;">
        <div class="d-flex align-items-center" style="gap:16px; padding-bottom: 24px;">
            <div class="circle circle-big d-flex justify-content-center align-items-center"
                [class]="'color'+configService.config.connectedEntityDetail.entity.entityInfo.getNameInitialColorIndex()">
                <div class="mat-headline">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.name.charAt(0).toUpperCase()}}
                </div>
            </div>
            <div class="mat-title" style="flex: 1 0 0;">
                {{configService.config.connectedEntityDetail.entity.entityInfo.name}}
            </div>
            <div class="d-flex align-items-start  ">
                <button matDialogClose="true" style="position: relative; top: -14px; left: 16px;" mat-icon-button>
                    <mat-icon class="eac-c1">close</mat-icon>
                </button>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="d-flex align-items-start justify-content-start flex-wrap" style="gap:24px 24px; padding-top: 24px;">
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Identificador</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.cif}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Adreça</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.address}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Codi oficial estadístic</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.ine10}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Codi postal</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.postalCode}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Tipus</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.nameTypeCode}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Localitat</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.town}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Demarcació territorial</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.delegation}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-start" style="min-width: 280px;flex: 1 0 0;">
                <div class="mat-subheading-1">Comaca</div>
                <div class="eac-label-input eac-c1">
                    {{configService.config.connectedEntityDetail.entity.entityInfo.region}}
                </div>
            </div>
        </div>
    </div>
</ng-template>